import { FC } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { FontsEnum } from '../../../constants/fonts'
import QuantityChanger from './QuantityChanger'

interface ItemWithQuantityProps {
    children: string
    readyQuantity: number
    totalQuantity: number
    color: string
    withQuantityChange: boolean
    isLoading: boolean
    onQuantityDecrease: () => void
    onQuantityIncrease: () => void
}

const ItemWithQuantity: FC<ItemWithQuantityProps> = ({
    children,
    readyQuantity,
    totalQuantity,
    color,
    withQuantityChange,
    isLoading,
    onQuantityDecrease,
    onQuantityIncrease,
}) => {
    return (
        <View style={styles.container}>
            <Text adjustsFontSizeToFit numberOfLines={3} style={[styles.text, { color }]}>
                {children}
            </Text>
            <QuantityChanger
                readyQuantity={readyQuantity}
                totalQuantity={totalQuantity}
                color={color}
                withQuantityChange={withQuantityChange}
                isLoading={isLoading}
                onQuantityDecrease={onQuantityDecrease}
                onQuantityIncrease={onQuantityIncrease}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 5,
    },
    text: {
        flexShrink: 1,
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 20,
    },
})

export default ItemWithQuantity
